import { tracker } from '../track';
import { formatItemName, formatPrice, formattedSimples, mapArticleToGA4EcommerceItem, toItemAvailability, } from '../../helpers';
export const trackViewItemList = (payload, options) => {
    try {
        const { element, itemListName, items, itemsLength } = payload;
        tracker.track('GA4-EEC-view_item_list', {
            event_name: 'view_item_list',
            view_item_list: {
                element: element || null,
                item_list_id: null,
                item_list_name: itemListName || null,
                length: itemsLength || items.length || 0,
                items: items.map((item, index) => {
                    var _a;
                    return mapArticleToGA4EcommerceItem(Object.assign({ affiliation: String(item.categoryId), discount: item.savings || null, early_access_item: item.plusEarlyAccess ? 1 : 0, index, is_sustainable: item.sustainable ? 1 : 0, item_availability: toItemAvailability(item.stockStatus), item_brand: item.brandCode, item_id: item.sku, item_name: formatItemName(item), price: formatPrice(item.specialPrice), product_gender: (item.gender || []).toString() || null, promotion_id: item.campaignIdentifier, size_availability: formattedSimples(item, 'filterValue') }, (_a = options === null || options === void 0 ? void 0 : options.customMapper) === null || _a === void 0 ? void 0 : _a.call(options, item)));
                }),
            },
        });
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('[@browsing/tracker] Tracking `view_item_list` failed.', e);
    }
};
